"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REVISION_CHAT_EVENT_KINDS = void 0;
exports.isRevisionChatEventKind = isRevisionChatEventKind;
exports.isRevisionChatMessage = isRevisionChatMessage;
exports.formatRevisionChatMoney = formatRevisionChatMoney;
exports.revisionChatFirmName = revisionChatFirmName;
exports.buildRevisionChatEventMetadata = buildRevisionChatEventMetadata;
exports.revisionChatCopy = revisionChatCopy;
exports.revisionChatPlainText = revisionChatPlainText;
exports.revisionChatEventRow = revisionChatEventRow;
const message_entity_js_1 = require("../entities/message.entity.js");
const round_money_js_1 = require("../money/round-money.js");
exports.REVISION_CHAT_EVENT_KINDS = [
    message_entity_js_1.ChatEventKind.REVISION_PROPOSED,
    message_entity_js_1.ChatEventKind.REVISION_ACCEPTED,
    message_entity_js_1.ChatEventKind.REVISION_CHANGES_REQUESTED,
    message_entity_js_1.ChatEventKind.REVISION_WITHDRAWN,
];
const REVISION_CHAT_KIND_SET = new Set(exports.REVISION_CHAT_EVENT_KINDS);
function isRevisionChatEventKind(kind) {
    return !!kind && REVISION_CHAT_KIND_SET.has(kind);
}
function isRevisionChatMessage(message) {
    const metadata = message?.metadata;
    if (!metadata)
        return false;
    return isRevisionChatEventKind(metadata.chatEventKind) || Boolean(metadata.revisionId);
}
function formatRevisionChatMoney(value) {
    return Math.abs((0, round_money_js_1.roundMoney)(value)).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
function revisionChatFirmName(name) {
    const trimmed = String(name ?? "").trim();
    return trimmed || "The business";
}
function buildRevisionChatEventMetadata(input) {
    return {
        chatEventKind: input.kind,
        firmName: revisionChatFirmName(input.firmName),
        revisionId: input.revisionId,
        revisionNumber: input.revisionNumber ?? null,
        contractDelta: (0, round_money_js_1.roundMoney)(input.contractDelta),
        contractValueAfter: (0, round_money_js_1.roundMoney)(input.contractValueAfter),
    };
}
function revisionChatCopy(metadata) {
    const firm = revisionChatFirmName(metadata.firmName);
    const delta = (0, round_money_js_1.roundMoney)(metadata.contractDelta);
    const after = (0, round_money_js_1.roundMoney)(metadata.contractValueAfter);
    switch (metadata.chatEventKind) {
        case message_entity_js_1.ChatEventKind.REVISION_PROPOSED:
            return {
                title: `${firm} has proposed changes.`,
                body: proposedMoneyLine(delta),
                actionLabel: "Review",
                weight: "card",
            };
        case message_entity_js_1.ChatEventKind.REVISION_ACCEPTED:
            return {
                title: "Your project has been updated.",
                body: `Contract value is now ${formatRevisionChatMoney(after)}.`,
                actionLabel: "View details",
                weight: "card",
            };
        case message_entity_js_1.ChatEventKind.REVISION_CHANGES_REQUESTED:
            return {
                title: `You asked ${firm} to adjust the changes`,
                body: "",
                actionLabel: "View",
                weight: "slim",
            };
        case message_entity_js_1.ChatEventKind.REVISION_WITHDRAWN:
            return {
                title: `${firm} withdrew the proposed changes`,
                body: "",
                actionLabel: "View",
                weight: "slim",
            };
        default:
            return {
                title: "Update",
                body: "",
                actionLabel: null,
                weight: "slim",
            };
    }
}
function revisionChatPlainText(metadata) {
    const copy = revisionChatCopy(metadata);
    return [copy.title, copy.body].filter(Boolean).join(" ");
}
function revisionChatEventRow(conversationId, metadata) {
    return {
        conversationId,
        senderRole: message_entity_js_1.SenderRole.SYSTEM,
        senderId: null,
        text: revisionChatPlainText(metadata),
        metadata,
    };
}
function proposedMoneyLine(delta) {
    if (delta > 0)
        return `Contract value would go up by ${formatRevisionChatMoney(delta)}.`;
    if (delta < 0)
        return `Contract value would go down by ${formatRevisionChatMoney(delta)}.`;
    return "Contract value is unchanged.";
}
